<script setup lang="ts">
import {arrow, computePosition, flip, offset, type Placement, shift} from "@floating-ui/dom";
import {type PropType, ref} from "vue";
import {RiInformationLine} from "@remixicon/vue";

interface Oppside {
  oppiside: any
}

const referenceRef = ref()
const floatingRef = ref()
const arrowRef = ref()
const isHidden = ref(true)

const props = defineProps({
  content: String,
  title: String,
  placement: {
    type: String as PropType<Placement>,
    default: "bottom"
  }
})

const calculatePosition = (async () => {
  //@ts-ignore
  const {x, y, middlewareData, placement} = await computePosition(
      referenceRef.value,
      floatingRef.value,
      {
        placement: props.placement,
        middleware: [
          offset(8),
          flip(),
          shift({padding: 5}),
          arrow({element: arrowRef.value})
        ],
  })

  Object.assign(floatingRef.value.style, {
    left: `${x}px`,
    top: `${y}px`
  })

  // @ts-ignore
  const { x: arrowX, y: arrowY } = middlewareData.arrow;

  const opposedSide: any = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom",
  }[placement.split("-")[0]]

  // @ts-ignore
  Object.assign(arrowRef.value.style, <object>{
    left: arrowX ? `${arrowX}.px`: "",
    top: arrowX ? `${arrowY}.px`: "",
    bottom: "",
    right: "",
    [opposedSide]: <any>"-4px"
  })
})

const hide = () => {
  isHidden.value = true
}

const show = () => {
  isHidden.value = false
  calculatePosition()
}

</script>

<template>
  <div class="inline-block">
    <div
        ref="referenceRef"
        class="inline-block"
        @mouseenter="show"
        @mouseleave="hide"
        @focus="show"
        @blur="hide"
    >
      <slot />
    </div>
    <div
        ref="floatingRef"
        :class="[
            'absolute top-0 left-0 z-50 bg-gray-900 text-sm text-white px-3 py-1.5 rounded-lg cursor-default w-60',
            isHidden && 'hidden'
        ]">
      <div class="flex flex-col">
        <span class="text-center flex justify-center"><RiInformationLine /></span>
        <h3 class="font-medium text-center">{{ props.title }}</h3>
        <div>{{ props.content }}</div>
      </div>
      <div class="absolute bg-gray-900 h-[8px] w-[8px] rotate-45" ref="arrowRef"></div>
    </div>
  </div>
</template>
